import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";

// Tema tercihini sayfa yenilense bile koru (koyu/açık mod)
const savedTheme = localStorage.getItem('theme');
if (savedTheme === 'dark' || savedTheme === 'light') {
  document.documentElement.setAttribute('data-bs-theme', savedTheme);
}
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';

import '@/assets/scss/config/default/app.scss';
import "leaflet/dist/leaflet.css";
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'

import mqttService from "@/services/mqtt.service";

// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();


// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);



AOS.init({
  easing: 'ease-out-back',
  duration: 1000
});

// Eğer kullanıcı login ise MQTT'yi başlat (VUE_APP_MQTT_ENABLED !== "false" ise).
// Gerekli env: VUE_APP_MQTT_URL (wss), VUE_APP_MQTT_APP (trainer/member)
// Kimlik: getCredentials() ile userId + token kullanılıyor; SaveBrokerAuth start içinde tetiklenir.
try {
  const mqttEnabled =
    String(process.env.VUE_APP_MQTT_ENABLED || "")
      .trim()
      .toLowerCase() === "true";

  if (mqttEnabled && localStorage.getItem("jwt")) {
    mqttService.start().catch((e) => {
      console.error("[MQTT] start() başarısız:", e?.message || e);
    });
  }
} catch (e) {
  // ignore
}

// MQTT'den DeleteUserDeviceMsg gelince (cihaz yetkisi iptal) logout yap
window.addEventListener("ptduo:logout", () => {
  mqttService.stop();
  router.push("/logout");
});

createApp(App)
  .use(store)
  .use(router)
  .use(VueApexCharts)
  .use(BootstrapVueNext)
  .component(VueFeather.type, VueFeather)
  .directive("maska", vMaska)
  .use(i18n)
  .use(VueSweetalert2)
  .use(vClickOutside).mount('#app');
